<template>
  <div>
    <v-row justify="center" style="min-height:auto;">
      <v-col sm="12" md="12" lg="12" xl="12" style="background-color: #fff;height:100%;padding-left:0;">
        <div class="wrap search">
          <v-container class="px-4 py-0">
              <v-row no-gutters class="pt-0 mb-0 px-2">
                <v-col cols="12">
                  <div :class="{'sidemenu': true, 'open': menuactive}" id="scroll-target-l" @mouseover="menuactive = true" @mouseleave="menuactive = false">

                    <div class="title" style="float:left; width:50%;padding-top:4px;padding-left:1rem;">
                      <v-icon
                        v-if="!menuactive"
                        class="ml-2 mr-1 mt-2"
                        style="float:right;"
                        size="22"
                        color="white"
                        >mdi-menu-down</v-icon>
                      <v-icon
                        v-else
                        class="ml-2 mr-1 mt-2"
                        style="float:right;"
                        size="22"
                        color="white"
                        >mdi-menu-up</v-icon>                        
                      <span>{{ $t('Research fields') }}</span>
                    </div>

                    <div style="float:right;width:49%" class="search-wrapper">
                      <div>
                        <div class='tag-input'>
                          <div v-for='(tag) in selectedTags' :key='tag.id' class='tag-input__tag'>                        
                            {{ $t(tag.name) }}
                            <span class="closetag" @click="remove(tag)">x</span>
                          </div>
                          <v-text-field
                            type='text' 
                            v-model="searchtmp" 
                            outlined
                            dense
                            :placeholder="$t('Search Transferpass')" 
                            class='tag-input__text'
                            v-on:keyup.enter="submitsearch"
                            append-icon="mdi-close"
                            @click:append="reset"
                          >
                          </v-text-field>
                          <v-btn 
                            @click="submitsearch" 
                            style="height:42px;" 
                            depressed
                            color="#eff9ff"
                            >
                            <v-icon>mdi-magnify</v-icon>
                          </v-btn>
                        </div>
                        <!--
                        <input type="text" v-model="search" placeholder="Testbed durchsuchen"/>
                        -->
                      </div>
                      <div v-if="filtertags.length > 0 && tagsdisplay" class="tagcloud">
                        <a v-for="(tag, index) in filtertags" :key="index" @click="addTag(tag.id, tag.name)">{{ $t(tag.name) }}</a>
                      </div>          
                    </div>

                    <div :class="{'list_wrap': true, 'active': menuactive}" style="position:relative;clear:both">
                      <div class="list">
                        <SideMenuFront class="" :selection="selection"></SideMenuFront>
                      </div>
                      <v-icon
                        class="ml-2 mr-1 mt-2"
                        style="position:absolute;right:0;bottom:6px;"
                        size="22"
                        @click="menuactive = false"
                        >mdi-close</v-icon>
                    </div>
                  </div>
                </v-col>
              </v-row>
          </v-container>

          <!--  FILTER RESULTS  -->

          <v-container class="d-flex">
              <!--<transition-group v-if="searchMode === 0" tag="v-row" id="results" style="width:100%;padding-top:20px;" name="fade" class="no-gutters" mode="out-in">-->
              <v-row v-if="searchMode === 0" id="results" style="width:100%;padding:20px;" class="">
                <v-col cols="12" sm="6" md="4" lg="3" v-for="(post, key1) in filteralltypes"
                  :key="key1+0"
                  class="d-flex card"
                >
                  <div contain class="card-content h-100 d-flex flex-column fill-height">
                    <div v-if="post.src">
                        <router-link v-if="post.type === 'field'" :to="'/'+$home+(post.alias ? post.alias : post.id)" @click.native="$scrollToTop">
                          <img :src="post.paththumb" :alt="post.title" class="img-responsive">
                        </router-link>
                        <router-link v-else :to="'/'+$home+'p/'+post.type+'/'+(post.alias ? post.alias : post.id)" @click.native="$scrollToTop">
                        <img :src="post.paththumb" :alt="post.title" class="img-responsive">
                        </router-link>
                    </div>
                    <div class="item-desc">                              
                        <!--<span class="type">{{ $t(post.type) }} | {{ post.area }}</span>-->
                        <span class="type" v-if="post.area && post.area.length > 0">{{ post.area[0].name }}</span>
                        <span class="type" v-else></span>
                        <router-link v-if="post.type === 'field'" :to="'/'+$home+ (post.alias ? post.alias : post.id) ">
                          <h3 v-if="$i18n.locale === 'de'">{{ post.title }}</h3>
                          <h3 v-else>{{ post.title_en }}</h3>
                        </router-link>
                        <router-link v-else :to="'/'+$home+'p/'+post.type+'/'+ (post.alias ? post.alias : post.id) ">
                          <h3 v-if="$i18n.locale === 'de'">{{ post.title }}</h3>
                          <h3 v-else>{{ post.title_en }}</h3>
                        </router-link>
                        <div class="tags">
                        <a v-for="(tag, key2) in post.tags" :key="key2+0" @click="addTag(tag.id, tag.name)">{{ $t(tag.name) }}</a>
                        </div>

                        <!--
                        <a v-for="category in post.categories" :key="category.id" :href="'/blog?category=' + category.slug">{{ category.title }} <br></a>
                        <p class="font-12">Posted on {{ post.published_at }}</p>
                        -->
                    </div>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="searchMode === 1">
                <v-data-table
                  :headers="headers"
                  :items="filteralltypes"
                  :footer-props="{
                    'items-per-page-options': [10, 20, 30, 40, 50]
                  }"
                  :items-per-page="30"                      
                  :search="search"
                  item-key="title"
                  class="elevation-1 search-table"
                  >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr
                        v-for="(item, index) in items"
                        :key="index"
                      >
                        <td>
                          <img :src="item.paththumb" title="" v-if="item.paththumb" height="40px" />                                                                                                            
                        </td>
                        <td class="name">                                            
                          <router-link :to="'/'+$home+'p/'+item.type+'/'+item.id" >
                          {{ item.title }}
                          </router-link>                                   
                          <span class="toptitle"><i>{{ $t(item.type) }}</i></span>                             
                        </td>
                        <td>                                  
                            <span v-for="(ar) in item.area" :key="ar.name">
                              <i>{{ ar.name }}</i>
                            </span>                                  
                        </td>
                        <td style="padding:10px 6px;">                                                        
                            <div class="tags">
                              <i v-for="(tag) in item.tags" :key="tag.id" @click="addTag(tag.id, tag.name)" class="tag">
                              {{ tag.name }}                                
                              </i>
                            </div>
                        </td>
                        <td>
                          {{ item.region }}
                            <div v-for="(partner) in item.partners" :key="partner.id" class="partner">
                            <img :src="'/'+$home+'graf/'+partner.src" style="width:50px;">
                            </div>
                        </td>
                        <td>
                          <div v-if="item.usecase && item.usecase.length > 0">
                            
                            <v-menu 
                              bottom
                              left
                              :offset-x="true"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  v-bind="attrs"
                                  v-on="on"
                                >Anwendungen ({{ item.usecase.length }})</span>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(item, index) in item.usecase"
                                  :key="index"
                                >
                                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>

                          </div>
                        </td>                                
                        <td>
                          <router-link :to="'/'+$home+'p/devices/'+item.id" v-if="item.devices && item.devices.length > 0">
                          ({{ item.devices.length }})
                          </router-link>                                                               
                        </td>                                                                                      
                      </tr>
                    </tbody>
                    </template>
                  </v-data-table>
              </v-row>
          </v-container>
        </div> 
      </v-col>
    </v-row>
    <Footer></Footer>
  </div>
</template>

<script>

//import Setting from '../components/footer/Setting';
import SideMenuFront from './navigation/SideMenuFront';
// import Contact from '../components/elements/Contact';
//import VoerroTagsInput from '@voerro/vue-tagsinput';
import Footer from './elements/Footer';

export default {
  name: 'Layout',
  props: ['query','searchx','pagex'],
  components: {
      SideMenuFront,
      // Contact,
      Footer,
      //"tags-input": VoerroTagsInput
  },
  data() {
    return {
      menuactive: false,
      loaded: false,
      selectedTags: [],
      existingTags: [
        {key: 'web-development', value: 'Web Development' },
        {key: 'php', value: 'PHP' },
        {key: 'javascript', value: 'JavaScript' }
      ],
      headers: [
        { text: '',
          align: 'start',
          value: 'paththumb',
          width: '10%'
        },
        { text: 'Name',          
          value: 'title',
          align: 'start',
          width: '10%'
        },
        {
          text: 'Bereich',
          value: 'area',
        },                        
        {
          text: 'Themen',
          value: 'tags'
        },
        {
          text: 'Partner',
          value: 'partner',
          sortable: false
        },        
        {
          text: 'Anwendungen',
          value: 'fields'
        },        
        {
          text: 'Equipment',
          value: 'responsible',
          sortable: false
        }                     
      ],
      // search: '',
      searchtmp: '',
      searcht: null,
      usecase: false,
      testfield: false,
      testfields: [],
      devices: [],
      tags: [],
      tagstest: ['hello', 'world'],
      //partners: [],
      tagssearch: [],
      tagsdisplay: false,
      tagsselected: [],
      usecases: [],      
      //svitch: this.searchMode,
      selection: {
        field:false,
        // usecase:false,
        // device:false,
        // partners: [],
        areas: []
      },
      alltypes: []
    }
  },

  methods: {
      scrollToTop() {
        window.scrollTo(0,0);
      },
      getTestfields() {
          this.axios.get( this.$config.host+"/testfieldsf" ).then(response => (
            this.testfields = response.data,
            // this.getUsecases()
            this.getDevices()
          ));
      },
      getUsecases() {
          this.axios.get( this.$config.host+"/usecasesf" ).then(response => (
            this.usecases = response.data,
            this.getDevices()
          ));
      },
      getDevices() {
          this.axios.get( this.$config.host+"/devices" ).then(response => (
            this.devices = response.data,                        
            // this.merge(this.testfields, this.usecases, this.devices)            
            this.merge(this.testfields, this.devices)
          ));
      },
      getTags() {
          this.axios.get( this.$config.host+"/tags" ).then(response => (
            this.tags = response.data,
            this.getQuery(this.query)
          ));
      },
      getTagsActive() {
          this.axios.get( this.$config.host+"/tagsactive" ).then(response => (
            this.tags = response.data,
            this.getQuery(this.query)
          ));
      },
      getAreas() {
        var self = this;
        this.axios.get( this.$config.host+"/areas" ).then(function (response) {                
          response.data.forEach(function (ar) {
            // console.log(ar);
            if(ar.id === 9 || ar.id === 10 || ar.id === 11) {
                self.selection.areas.push({name: ar.name, icon: ar.icon, active: false})
            }
          });                              
        });
      },            

      merge(a,b) {
          this.alltypes = a.concat(b);
      },
      getQuery(query) {
        var result = this.tags.find(el => el.name == query);
        if(result && result != -1) {
          this.addTag(result.id, result.name);
        }
      },
      reset() {        
        this.search = "";
        this.searchtmp = "";
        this.selectedTags = [];
      },
      remove (tag) {
        const index = this.selectedTags.map(function(item) { return item.id; }).indexOf(tag.id);

        // remove object
        this.selectedTags.splice(index, 1);      
      },
      addTag(id, name) {                
        // Add item to array
        this.selectedTags.push({id:id,name:name});

        // Find duplicates
        const ids = this.selectedTags.map(o => o.id);
        const filtered = this.selectedTags.filter(({id}, index) => !ids.includes(id, index + 1));
        this.selectedTags = filtered;
        this.search = "";       
        this.searchtmp = "";
      },
      setSearchMode (mode) {        
        this.$store.commit("setSearchMode", mode);
      },
      submitsearch () {        
        this.tagsdisplay = false;
        this.search = this.searchtmp;
      }

  },
  mounted() {
    this.getTestfields();
    this.getTagsActive();
    // this.getPartners();
    this.getAreas();
    this.searchtmp = this.$store.state.search.string ? this.$store.state.search.string : ''
    //this.getUsecases();
  },
  computed: {
      search: {
          get() { 
            return this.$store.state.search.string;
          },
          set(value) {
            this.$store.commit('setSearchString', value);
            // this.searchtmp = this.$store.state.search.string;
          }
      },
      searchMode: {      
          get() {            
            return this.$store.state.search.mode;
          },
          set(value) {
              this.$store.state.search.mode = value
          }
      },

      filtertags() {        
          return this.tags.filter(post => {
              return ( post.name.toLowerCase().includes(this.searchtmp.toLowerCase()) && this.searchtmp !== '' )
          })
      },

      filteralltypes() {

        // console.log('filteralltypes');
        
        if(this.alltypes.length < 1) return this.alltypes;

        // var categories = [];        
        var areas = [];
        // var partners = [];        
        
        this.selection.areas.forEach(function (ar) {        
          if(ar.active == true) areas.push(ar.name)
        });
          
        if(this.selectedTags.length > 0) {            

          // console.log("FILTER TAGS");

          var filterA = this.alltypes.filter(post => {

            var found = false;

            this.selectedTags.forEach(function (tag) {

                if( post.tags && post.tags.find(el => el.id == tag.id) ) {                    
                  found = true;
                }

            });
            
            return ( 
                post.title.toLowerCase().includes(this.search.toLowerCase())
                // post.type.toLowerCase().includes(this.search.toLowerCase()) 
              ) &&
              found == true &&
              // (
              //  (categories.indexOf(post.type) > -1 && categories.length > 0 ) || categories.length == 0
              // ) &&
              ( 
                ( post.area && post.area.filter(ar => areas.includes(ar.name)).length > 0 && areas.length > 0 ) || areas.length == 0
              ) &&
              // ( 
              //  ( post.partners && post.partners.filter(pt => partners.includes(pt.name)).length > 0 && partners.length > 0 ) || partners.length == 0
              // ) &&
              post.published == true 

          })

          return filterA;

        } else {

          console.log("FILTER REST");

          var filterB = this.alltypes.filter(post => {
              
              return ( 
                  post.title.toLowerCase().includes(this.search.toLowerCase()) || 
                  (post.responsible && post.responsible.filter(resp => resp.name.toLowerCase().includes(this.search.toLowerCase())).length > 0) ||
                  (post.elements && post.elements.filter(elem => elem.content.toLowerCase().includes(this.search.toLowerCase())).length > 0)
                ) &&
                ( 
                  ( post.area && post.area.filter(ar => areas.includes(ar.name)).length > 0 && areas.length > 0 ) || areas.length == 0
                ) &&
                post.published == true

            })

          filterB.sort((a, b) => {
            b.areaname.localeCompare(a.areaname)

            const nameCompare = a.areaname.localeCompare(b.areaname);

            // If names are equal, sort by age
            if (nameCompare === 0) {
              return a.title.localeCompare(b.title);
            }
            
            return nameCompare;

          });

          console.log("SORTED:");
          console.log(filterB);

          return filterB;

        }
        
      }

  },
  watch: {
    searcht(val) {
      if(val !== '') {
        this.tagssearch = this.tags;
      } else {
        this.tagssearch = []
      }
    },
    filtertags() {      
      this.tagsdisplay = true
    }    
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

.container {
  background-color:#ffffff;
  max-width:1300px;
}
.container.topic {
  background-color:transparent;
}
.container .row {
  padding-top:30px;
}
.col img {
  max-width:100%;
}
.bordertop {
  border-top:2px solid #000;
}
.search-wrapper {
  padding-right:0px;
  background-color:#fff;
  height:40px;
}

/* tags */
.tag-input {
  width: 100%;  
  font-size: 0.9em;
  height: 42px;
  box-sizing: border-box;
  padding: 0 0 0 10px;
  display: flex;
}
.tag-input__tag {
  height: 30px;
  display: flex;
  justify-content: flex-start;
  margin-right: 10px;
  background-color: #e9e9e9;
  margin-top: 5px;
  line-height: 30px;
  padding: 0 5px 0 8px;
  border-radius: 5px;
  white-space: nowrap;
}

.tag-input__tag > span {
  cursor: pointer;
  opacity: 0.75;
}

.tag-input__text {
  border: none;
  outline: none;
  font-size: 0.9rem;
  line-height: 48px;
  background-color: transparent;
  display: flex;
  justify-content: flex-start;
  width:100%;
  padding:1px 4px 0;
}
.closetag {  
  display: inline-block;
  margin:0;
  padding:2px 0 0 5px;
  line-height: .8rem;
  font-size:.76rem;
}
.tagcloud {
  min-height:10px;
  border-bottom:1px solid #f5f5f5;  
  background-color: white;
  padding:6px 4px;
  position: relative;
  z-index:99;
}

/* /tags */
.v-data-table {
  width:100%;
}
.v-item-group .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.card-content {
  padding:0px;
  background-color:#f7f7f7;
  /*min-height:304px;*/
  box-shadow: 0 .085rem .25rem rgba(0,0,0,.12);
}
.card-content img {
  max-width:100%;
}
.card-content .item-desc {
  padding:4px 8px 12px;
  min-height:146px;
  position: relative;
}
.card {
  float:left;
  padding:12px;
}
.card a h3 {
  font-size:1rem;
  color:#333;
  padding:4px 2px 8px;
}
.card-content .tags {
  position: absolute;
  bottom: 0;
  padding: 6px 0;
}
.tags a,
.tagcloud a {
  display:inline-block;
  font-size:0.8rem;
  color:#999;
  font-style:italic;
  padding:1px 10px;
  margin:2px 2px;
  white-space: nowrap;
  color:#fff;
  background-color:#0076bc;
  border-radius:14px;
}
.tags a:hover,
.tagcloud a:hover {
  text-decoration:none;
  background-color: rgb(0,118,188,0.8);
}
.tags i,
.tagcloud i {
    background-color: #f5f5f5;
    margin-right:10px;
    display:inline-block;
    margin:2px 4px;
    padding: 2px 4px;
}
.type {
  font-size:0.76rem;
  color:#999;
  font-style:italic;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 1s;
}
.fade-leave-active {
  transition: 1s;
  opacity: 0;
}
.row span {
  width:100%;
}
.tablogo {
  float:left;
  margin:-6px 20px 0 0;
}
.tablogo img {
  height:30px;
}
.search-table {
  margin:0 16px;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  width: auto;
  padding:0 6px 0 0;
}

</style>

<style>

.tag-input > .v-text-field--outlined > .v-input__control > .v-input__slot > fieldset {
  border-width: 0px !important;
}
.tag-input > .v-text-field--outlined.v-input--is-focused fieldset {
  border: 0 !important;
}

.search-table th {
  padding:0 2px !important;  
}
.search-table td.name a {
  font-size:.8rem;
}
.search-table .toptitle {
  display: block;
  font-size: 0.8rem;
}
.search-table .toparea {
  display: block;
  font-size: 0.8rem;
}
</style>
